// extracted by mini-css-extract-plugin
export default {"buttons":"ReportParamsButtons__buttons___ZuCg1"};